require('./bootstrap');
// Import modules...
import { createApp, h } from 'vue';
import {
    createInertiaApp,
    Link, Head,
} from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';

//Fancybox (Enlarge Image)
import { Fancybox } from "@fancyapps/ui";

//Font awesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPhone,faMapMarkerAlt,faEnvelope } from "@fortawesome/free-solid-svg-icons";
library.add(faPhone,faMapMarkerAlt,faEnvelope);

// const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'My Webstore';

// const el = document.getElementById('app');


createInertiaApp({
    // title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            .use(plugin)
            .mixin({ methods: { route } })
            .component("font-awesome-icon", FontAwesomeIcon)
            // latest inertia removed Link and Head in global
            // re-register to continue using inertial-link and inertia-head
            .component('InertiaLink', Link)
            .component('InertiaHead', Head)
            .mount(el);
    },
});

InertiaProgress.init({ color: '#4B5563' });
